export const CONS = {
  title: 'Let us know your thoughts',
  description: `By clicking 'Submit', you agree that {{SHORT_APP_NAME}} may contact you and that your feedback will be used per our {{PRIVACY_POLICY_LINK}}`,
  contact_header: 'Tell us about yourself:',
  firstName: 'First Name',
  email: 'Email Address associated with your {{SHORT_APP_NAME}} account',
  phoneNumber: 'Phone Number',
  feedback: 'Please describe your {{APP_NAME}} app experience.',
  feedback_helper: 'Do not enter any personal information',
  privacyPolicyUrl: '',
  privacyPolicyLabel: 'privacy policy.',
  optionalLabel: '(optional)',
};

const APP_NAMES: Record<string, string> = {
  health100: 'Health100',
  cvs: 'CVS Health',
};

const SHORT_APP_NAMES: Record<string, string> = {
  health100: 'Health100',
  cvs: 'CVS',
};

const PRIVACY_POLICY_URLS: Record<string, string> = {
  health100: '/privacy_policy',
  cvs: '/retail/help/privacy_policy',
};

export const resolveText = (text: string, lob: string): string => {
  const appName = APP_NAMES[lob] ?? APP_NAMES.cvs;
  const shortAppName = SHORT_APP_NAMES[lob] ?? SHORT_APP_NAMES.cvs;
  return text.replace(/\{\{APP_NAME\}\}/g, appName).replace(/\{\{SHORT_APP_NAME\}\}/g, shortAppName);
};

export const resolveConsText = (lob: string): typeof CONS => {
  const r = (s: string) => resolveText(s, lob);
  return {
    ...CONS,
    description: r(CONS.description),
    feedback: r(CONS.feedback),
    email: r(CONS.email),
    privacyPolicyUrl: PRIVACY_POLICY_URLS[lob] ?? PRIVACY_POLICY_URLS.cvs,
  };
};

export const FEEDBACK_ERROR_TITLES = {
  DEFAULT: 'Correct the following errors'
};
export const FEEDBACK_VALIDATION = {
  FIRST_NAME_REQUIRED: 'Enter a first name',
  FIRST_NAME_INVALID: 'First name cannot exceed 40 characters',
  APP_VERSION_INVALID: 'App version cannot exceed 15 characters',
  LAST_NAME_REQUIRED: 'Enter a last name',
  LAST_NAME_INVALID: 'Last name cannot exceed 40 characters',
  FEEDBACK_REQUIRED: 'Enter feedback',
  FEEDBACK_INVALID: 'Feedback cannot exceed 1000 characters',
  EMAIL_REQUIRED: 'Enter an email address',
  EMAIL_INVALID: 'Enter a valid email address',
  PHONE_NUMBER_INVALID: 'Enter a valid phone number',
};
